import { getCompaniesList } from "../app/Admin/modules/AddSupervisor/_redux";

export const fetchCompanies = async (setCompanyOptions, setSelectedCompany) => {
    try {
        const response = await getCompaniesList();
        if (response?.data) {
            const formattedData = [
                {
                    value: -1,
                    company_id: -1,
                    label: "All"
                },
                ...response.data.map(company => ({
                    value: company.id,
                    company_id: company.id,
                    label: company.company_name
                }))
            ];

            setCompanyOptions(formattedData);
            setSelectedCompany(formattedData[0] || null);

            return formattedData; // ✅ return the data
        }
        return [];
    } catch (error) {
        console.error("Error fetching companies:", error);
        return [];
    }
};
